module.exports = __webpack_public_path__ + "static/media/huoyanshan_mobile.af3a15e5.png";